
import { dynamicSort } from './sort';


export function getProductUrl(productResp) {

	if(!productResp || !productResp.product_type) {
		return '';
	}

	let settingTypes = [
		'MOUNTING',
	];

	let bandTypes = [
		'GTS WED BAND',
		'LDS WED BAND',
	];

	let jewelryTypes = [
		'BRACELET',
		'EARRING',
		'RING',
		'NECKLACE',
	];

	if(settingTypes.includes(productResp.product_type)) {
		return 'setting/' + productResp.sku;
	} else if(bandTypes.includes(productResp.product_type)) {
		return 'band/' + productResp.sku;
	} else if(jewelryTypes.includes(productResp.product_type)) {
		return 'jewelry/' + productResp.sku;
	} else {
		return 'jewelry/' + productResp.sku;
	}	
}

export function getWishlistProductUrl(productResp) {

	if(!productResp || !productResp.attributes || !productResp.attributes.type) {
		return '';
	}

	let settingTypes = [
		'MOUNTING',
	];

	let bandTypes = [
		'GTS WED BAND',
		'LDS WED BAND',
	];

	let jewelryTypes = [
		'BRACELET',
		'EARRING',
		'RING',
		'NECKLACE',
	];

	if(settingTypes.includes(productResp.attributes.type)) {
		return 'setting/' + productResp.sku;
	} else if(bandTypes.includes(productResp.attributes.type)) {
		return 'band/' + productResp.sku;
	} else if(jewelryTypes.includes(productResp.attributes.type)) {
		return 'jewelry/' + productResp.sku;
	} else {
		return '';
	}	
}

// Depricated

// export function getMetalTypeDropdownData(price, metalBase) {
// 	let metalDDData = [
// 		{
// 			display: 'Metal Options',
// 			value: '',
// 		}
// 	];
// 	if(metalBase === null || metalBase === '' || parseInt(metalBase) == 14) {
// 		return metalDDData.concat([
// 			{
// 				display: '14K Yellow Gold',
// 				value: 'YG14',
// 			},
// 			{
// 				display: '14K White Gold',
// 				value: 'WG14',
// 			},
// 			{
// 				display: '14K Rose Gold',
// 				value: 'RG14',
// 			},
// 			{
// 				display: '18K Yellow Gold (+$' + (calcMetalMarkup(price, metalBase, 'YG18')).toString() + ')',
// 				value: 'YG18',
// 			},
// 			{
// 				display: '18K White Gold (+$' + (calcMetalMarkup(price, metalBase, 'WG18')).toString() + ')',
// 				value: 'WG18',
// 			},
// 			{
// 				display: '18K Rose Gold (+$' + (calcMetalMarkup(price, metalBase, 'RG18')).toString() + ')',
// 				value: 'RG18',
// 			},
// 			{
// 				display: 'Platinum (+$' + (calcMetalMarkup(price, metalBase, 'P')).toString() + ')',
// 				value: 'P',
// 			},
// 		]);
// 	} else {
// 		return metalDDData.concat([
// 			{
// 				display: '18K Yellow Gold',
// 				value: 'YG18',
// 			},
// 			{
// 				display: '18K White Gold',
// 				value: 'WG18',
// 			},
// 			{
// 				display: '18K Rose Gold',
// 				value: 'RG18',
// 			},
// 			{
// 				display: 'Platinum (+$' + (calcMetalMarkup(price, metalBase, 'P')).toString() + ')',
// 				value: 'P',
// 			},
// 		]);
// 	}
// }

export function reSortDiamonds(rawResults, filters) {
	let filteredResults = [];
	for(const res of rawResults) {

		if(filters && filters.priceMin && filters.priceMin > 0) {
			if(res.price < parseInt(filters.priceMin)) {
				continue;
			}
		}

		if(filters && filters.priceMax && filters.priceMax > 0) {
			if(res.price > parseInt(filters.priceMax)) {
				continue;
			}	
		}

		filteredResults.push(res);
	}

	if(filters && filters.sort && filters.sort.includes('price')) {

		console.log('short be sorting !');
		console.log(filters);

		if(filters.sort === 'price') {
			console.log('door a');
			return filteredResults.sort(dynamicSort('price', false));
		}
		if(filters.sort === '-price') {
			console.log('door b');
			return filteredResults.sort(dynamicSort('price', true));
		}
	}
	return filteredResults;
}

export function reSortProducts(rawResults, filters) {
	
	console.log('reSortProducts');

	const pricedResults = [];
	for(const pd of rawResults) {
		pricedResults.push(Object.assign({}, pd, {
			realPrice: getMinPrice(pd),
		}));
	}

	let filteredResults = [];
	for(const res of pricedResults) {

		if(filters && filters.priceMin && filters.priceMin > 0) {
			if(res.realPrice < parseInt(filters.priceMin)) {
				continue;
			}
		}

		if(filters && filters.priceMax && filters.priceMax > 0) {
			if(res.realPrice > parseInt(filters.priceMax)) {
				continue;
			}	
		}

		filteredResults.push(res);
	}

	if(filters && filters.sort && filters.sort.includes('price')) {

		if(filters.sort === 'sell_price') {
			return filteredResults.sort(dynamicSort('realPrice', false));
		}
		if(filters.sort === '-sell_price') {
			return filteredResults.sort(dynamicSort('realPrice', true));
		}
	}
	return filteredResults;
}

export function getMinPrice(product) {
	let minPrice = null;

	for(let i = 0; i < product.children.length; i++) {
		if((minPrice === null || product.children[i].price < minPrice) && product.children[i].price > 0) {
			minPrice = product.children[i].price;
		}
	}
	return minPrice;
}

function getMetalType(materialType) {
	if(!materialType) {
		return '';
	}
	switch(materialType) {
		case 'YG':
			return 'Yellow Gold';
		case 'WG':
			return 'White Gold';
		case 'RG':
			return 'Rose Gold';
		case 'TT':
			return 'Two-tone';
		case 'GG':
			return 'Gray gold';
		case 'PLAT':
			return 'Platinum';
		case 'STEEL':
			return 'Stainless Steel';
		case 'SS':
			return 'Sterling Silver';
		case '18/PT':
			return '18K Platinum';
		case '14/PT':
			return '14K Platinum';
		case 'PALL':
			return 'Palladium';
		case 'TITAN':
			return 'Titanium';
		case 'TUNG':
			return 'Tungsten';
		case 'ELY':
			return 'Elysium';
		case 'COBLT':
			return 'Cobalt';
		case 'TANT':
			return 'Tantalum';
		case 'TRI':
			return 'Tri-color';
		case 'WG/TA':
			return 'White Gold/Tantalum';
		case 'RG/TA':
			return 'Rose Gold/Tantalum';
		case 'YG/TA':
			return 'Yellow Gold/Tantalum';
		case 'TA/TI':
			return 'Tantalum/Titanium';
		case 'WG/PT':
			return 'White Gold/Platinum';
		case 'RG/PT':
			return 'Rose Gold/Platinum';
		case 'YG/PT':
			return 'Yellow Gold/Platinum';
		case 'WG/TI':
			return 'White Gold/Titanium';
		case 'YG/TI':
			return 'Yellow Gold/Titanium';
		case 'RG/TI':
			return 'Rose Gold/Titanium';
		case 'RG/PD':
			return 'Rose Gold/Palladium';
		default:
			return '';
	}
}

function getMetalChildName(type, karat, price, minPrice) {
	let karatValue = '';
	let colorValue = getMetalType(type);
	let priceValue = '';

	if(karat == 14) {
		karatValue = '14K ';
	} else if(karat == 18) {
		karatValue = '18K ';
	}

	if(price > minPrice) {
		priceValue = ' (+$' + (price - minPrice).toString() + ')';
	}

	return karatValue + colorValue + priceValue;
}

function getMetalChildValue(type, karat) {
	return karat ? type + karat.toString() : type;
}

function getMetalTypeChildElements(product) {

	let options = [];
	let minPrice = getMinPrice(product);

	for(let i = 0; i < product.children.length; i++) {

		let metalKarat = product.children[i].karat;
		let metalPrice = product.children[i].price;

		if(metalPrice === 0) {
			continue;
		}

		for(let j = 0; j < product.children[i].materials.length; j++) {

			let metalType = product.children[i].materials[j].material_type;
			options.push({
				display: getMetalChildName(metalType, metalKarat, metalPrice, minPrice),
				value: getMetalChildValue(metalType, metalKarat),
			});
		}
	}
	return options;
}

export function getMetalTypeChildDropdownData(product) {

	let metalDDData = [
		{
			display: 'Metal Options',
			value: '',
		}
	];
	return metalDDData.concat(getMetalTypeChildElements(product));
}

export function calcMetalMarkup(price, metalBase, metalType) {

	// Markups:
	// 14 -> 18: 13%
	// 14 -> P: 34%
	// 18 -> P: 18.6%
	let markup = 0.0;

	if(!metalType || metalType.includes('14')) {
		return 0;
	}

	if(metalBase === null || metalBase === '' || parseInt(metalBase) == 14) {
		if(metalType == 'P') {
			markup = 0.34;
		} else if(metalType.includes('18')) {
			markup = 0.13;
		} else {
			return 0;
		}
	} else if(metalType == 'P') {
		markup = 0.186;
	}
	return parseInt((Math.ceil((parseFloat(price) * markup) / 10)) * 10);
}

export function calcChildMetalMarkup(product, selectedMetalCode) {

	const karatSpecificMetals = [ 'YG14', 'YG18', 'WG14', 'WG18', 'RG14', 'RG18', 'GG14', 'GG18', 'TT14', 'TT18' ];

	if(!selectedMetalCode) {
		return 0;
	}

	let minPrice = getMinPrice(product);

	for(let i = 0; i < product.children.length; i++) {

		let metalKarat = product.children[i].karat;
		let metalPrice = product.children[i].price;

		if(metalPrice === 0) {
			continue;
		}

		for(let j = 0; j < product.children[i].materials.length; j++) {

			let metalType = product.children[i].materials[j].material_type;

			if(metalType == selectedMetalCode) {
				return metalPrice - minPrice;
			}

			if(karatSpecificMetals.includes(selectedMetalCode) && selectedMetalCode.includes(metalKarat.toString()) && selectedMetalCode.includes(metalType)) {
				return metalPrice - minPrice;
			}
		}
	}
	return 0;
}

export function designerFormatName(dbDesigner) {

	if(!dbDesigner) {
		return '';
	}

	switch(dbDesigner) {
		case 'DIAMONDS DIRECT NY':
			return 'Diamonds Direct Designs';
    	case 'A. JAFFE':
    		return 'A Jaffe';
    	case 'AMDEN JEWELRY':
    		return 'Amden';
    	case 'FREDERICK GOLDMAN, INC DIANA':
    		return 'Artcarved';
    	case 'BENCHMARK':
    		return 'Benchmark';
    	case "C. GONSHOR'S FINE JEWELRY":
    		return 'C. Gonshor';
    	case 'CHRISTIAN BAUER (PENN GEM)':
    		return 'Christian Bauer';
    	case 'CHRISTOPHER DESIGNS':
    		return 'Christopher Designs';
    	case 'CLASSIQUE CREATIONS':
    		return 'Classique Creations';
    	// case 'FREDERICK GOLDMAN, INC DIANA':
    	// 	return 'Diana';
    	case 'FANA':
    		return 'Fana';
    	case 'FURRER-JACOT':
    		return 'Furrer Jacot';
    	case 'GABRIEL&CO':
    		return 'Gabriel & Co.';
    	// case 'FREDERICK GOLDMAN, INC DIANA':
    	// 	return 'Goldman';
    	case 'KIRK KARA':
    		return 'Kirk Kara';
    	case 'MASTOLONI & SONS INC.':
    		return 'Mastoloni';
    	case 'ODELIA BY AV JEWELRY':
    		return 'Odelia';
    	case 'SES CREATIONS':
    		return 'SES Creations';
    	case 'SIMON G. JEWELRY INC.':
    		return 'Simon G.';
    	case 'SPECTRUM':
    		return 'Sylvie';
    	case 'TACORI BRIDAL':
    		return 'Tacori';
    	case 'TACORI FASHION':
    		return 'Tacori';
    	case 'PAUL WINSTON/ TRUE ROMANCE':
    		return 'True Romance';
    	case 'VERRAGIO':
    		return 'Verragio';
    	case 'MICHAEL M':
    		return 'Michael M';
    	case 'INTERNATIONAL JEWELRY MKTING':
    		return 'IJM';
    	case 'BRILLIANT ELEMENTS(CARAT WORLD':
    		return 'Brilliant Elements';
    }
    return dbDesigner;
}




// WEBPACK FOOTER //
// ./src/utils/product.jsx